/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const recommendationsUploadCsvCreateStatus200Schema = z.any();

export const recommendationsUploadCsvCreateResponseSchema = recommendationsUploadCsvCreateStatus200Schema;

export const recommendationsUploadCsvCreateDataSchema = z
	.object({
		file: z.instanceof(File).describe("CSV файл с рекомендациями"),
	})
	.optional();
